export default __webpack_public_path__ + "static/media/anyni2.830df0d6.jpeg";